const second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;
let countdownTimer = document.getElementById('countdown-timer');

// example: <div id="countdown-timer" data-time="Apr 25, 2020 06:00:00">
if (countdownTimer != undefined && countdownTimer.dataset.time != undefined) {
let countDown = new Date(countdownTimer.dataset.time).getTime(),
    x = setInterval(function() {    

      let now = new Date().getTime(),
          distance = countDown - now;

          document.getElementById('countdown-days').innerText = Math.floor(distance / (day)),
          document.getElementById('countdown-hours').innerText = Math.floor((distance % (day)) / (hour)),
          document.getElementById('countdown-minutes').innerText = Math.floor((distance % (hour)) / (minute)),
          document.getElementById('countdown-seconds').innerText = Math.floor((distance % (minute)) / second);

      //do something later when date is reached
      if (distance < 0) {
        clearInterval(x);
        document.getElementById('countdown-incomplete').classList.add('hide');
        document.getElementById('countdown-complete').classList.remove('hide');
      }

    }, second)
}